import React from 'react'
import { M_Table } from 'src/components/M_Components'

export const FuelTax = ({ roles }) => {

    return (
        <M_Table entityName={'FuelTax'} filtersOnTable rolePermissions={roles} />
    )
}